
<template>
  <div id="ana">
    <v-container fluid>
      <div class>
        <span style="color:#ffffff">數據分析</span>
      </div>

      <v-row>
        <v-col
          cols="6"
          md="6"
          sm="12"
        >
          <v-select
            v-model="fieldListValue"
            :items="fieldList"
            label="選擇場域"
            solo
            @input="fieldChangeAna"
          />
        </v-col>
        <v-col
          cols="6"
          md="6"
          sm="12"
        >
          <v-select
            v-model="didListValue"
            :items="didList"
            label="設備編號"
            solo
            @input="didChange"
          />
        </v-col>
        <v-col
          cols="12"
          md="12"
          sm="12"
        >
          <v-checkbox
            v-for="(item, index) in fieldSensorList"
            :key="index"
            v-model="item.value"
            dark
            color="#ffff00"  
            hide-details="false" 
            class="checkbox"         
            :label="`${item.val_name.toString()}`"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="6"
          md="6"
          sm="6"
        >
          <v-select
            v-model="fieldListValue2"
            :items="fieldList"
            label="選擇場域"
            solo
            @input="fieldChangeAna2"
          />
        </v-col>
        <v-col
          cols="6"
          md="6"
          sm="6"
        >
          <v-select
            v-model="didListValue2"
            :items="didList2"
            label="設備編號"
            solo
            @input="didChange2"
          />
        </v-col>

        <v-col
          cols="12"
          md="12"
          sm="12"
        >
          <v-checkbox
            v-for="(item, index) in fieldSensorList2"
            :key="index"
            v-model="item.value"
            hide-details="false"
            dark
            color="#ffff00"  
            class="checkbox"
            :label="`${item.val_name.toString()}`"
          />
        </v-col>
      </v-row>
      <div class="searchbg1">
        <v-row>
          <v-col
            cols="6"
            md="6"
            sm="6"
          >
            <v-datetime-picker 
              v-model="fromdatetime"
              class="dateselect"
             
              label="開始日期:"
            />
          </v-col>
          <v-col
            cols="5"
            md="3"
            sm="3"
          >
            <v-datetime-picker
              v-model="todatetime"
              label="結束日期:"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="6"
            md="6"
            sm="6"
          >
            <v-btn
              outlined  
              dark
              @click="serachBtn"
            >
              查詢
            </v-btn>

            <export-excel
              v-show="exportBtnShow"
              class="btn btn-default"
              :data="json_data"
              :fields="json_fields"
              worksheet="My Worksheet"
              name="filename.xls"
            >
              <v-btn outlined>
                匯出檔案
              </v-btn>
            </export-excel>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="12"
            class="chartDiv"
            style=""
          >
            <line-example
              v-if="chartshow"
              :display="true"
              :chart="chartAna"
            />
          </v-col>
        </v-row>

        <v-progress-linear
          v-show="showloading"
          indeterminate
          color="green"
        />
        <v-snackbar v-model="snackbar">
          {{ text }}
          <template #action="{ attrs }">
            <v-btn
              color="pink"
              text
              v-bind="attrs"
              @click="snackbar = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
        <form
          ref="formContainer"
          class="vld-parent"
          @submit.prevent="submit"
        />
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import Moment from "moment";
import "@fortawesome/fontawesome-free/css/all.css";
import LineExample from "./LineChartAna.js";
import { extendMoment } from "moment-range";

import Cookies from "js-cookie";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import DatetimePicker from "vuetify-datetime-picker";
 import 'vuetify-datetime-picker/src/stylus/main.styl'
Vue.use(Loading);
Vue.use(DatetimePicker);

const moment = extendMoment(Moment);


 

export default {
  components: {
    LineExample,
  },
  data: () => ({
    fullPage: true,
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    menu3: false,
    modal: false,
    menu2: false,
    exportBtnShow: false,
    showloading: false,
    fromdatetime: new Date(),
    todatetime: new Date(),
    updatetime: "",
    fieldList: [],
    deviceList: ["01"],
    fieldSensorList: [],
    fieldSensorList2: [],
    fieldSensorValue: "",
    fieldSensorValue2: "",
    didListValue: "01",
    fieldListValue: "",
    didListValue2: "01",
    fieldListValue2: "",
    didList: [],
    didList2: [],
    filterDevice: {},
    filterDevice2: {},
    chartAna: {},
    chartshow: false,
    snackbar: false,
    text: "",
    
     

    json_fields: {
      val_name: "val_name",
      did: "did",
      value: "value",
      val_unit: "val_unit",
      dat: "dat",
    },
    json_data: [
      {
        val_name: "溫度",
        did: "1",
        value: "30",
        val_unit: "oC",
        dat: "2020-09-15 00:00",
      },
    ],
    searchagain: 0,
    twice: true,
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
          size : "16px",
        },
      ],
    ],
    backgroundColor: [
      "yellow",
      "red",
      "#D2B4DE",
      "#C28535",
      "#8AAE56",
      "#B66C46",
      "gray",
      "#F2F3F4",
    ],
  }),
  computed: {
    myStyles() {
      return {
        height: "400px",
        width: "100%",
        position: "relative",
      };
    },
    easing() {
      const { easingFct, easingType } = this;
      return [easingFct, easingType].join(".");
    },
    host() {
      return this.$store.state.host;
    },
    loginInfo() {
      return this.$store.state.loginInfo;
    },
    loginUID() {
      return this.$store.state.loginUID;
    },
    exec_cust_gateway_000() {
      return this.$store.state.exec_cust_gateway_000;
    },
  },
  mounted: function () {
    Cookies.set("url", "/Analysis");

    this.updatetime = moment().format("YYYY-MM-DD HH:mm:ss");
    let nform = {
      cust_id: this.loginInfo.cust_id,
    };
    this.fieldList = [];
    this.$store
      .dispatch("exec_cust_gateway_000", nform)
      .then((res) => {
        if (this.loginUID.superuser == "0") {
          nform = {
            cust_id: this.loginInfo.cust_id,
            uid: this.loginInfo.uid,
          };
          this.$store
            .dispatch("exec_uid_gateway_000", nform)
            .then((res) => {
              if (res != null && res.length > 0) {
                for (var i = 0; i < res.length; i++) {
                  let gw_no = res[i].gw_no;

                  for (var j = 0; j < this.exec_cust_gateway_000.length; j++) {
                    let item = this.exec_cust_gateway_000[j];

                    if (gw_no == item.ip_adrs) {
                      this.fieldList.push(item.gw_desc);
                    }
                  }
                }

                if (this.fieldList != null && this.fieldList.length > 0) {
                  this.fieldListValue = this.fieldList[0];
                  this.fieldListValue2 = this.fieldList[0];
                }
                this.fieldChangeAna(this.fieldListValue);
                this.fieldChangeAna2(this.fieldListValue2);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.fieldList = this.exec_cust_gateway_000.map(function (item) {
            return item.gw_desc;
          });

          if (this.fieldList != null && this.fieldList.length > 0) {
            this.fieldListValue = this.fieldList[0];
            this.fieldListValue2 = this.fieldList[0];
          }

          this.fieldChangeAna(this.fieldListValue);
          this.fieldChangeAna2(this.fieldListValue2);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    //this.fromdatetime = new Date();
    //this.fromdatetime.setHours(this.fromdatetime.getHours() - 2);
  },
  methods: {
    submit() {},
    onCancel() {
      console.log("User cancelled the loader.");
    },
    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    fieldChangeAna(val) {
      if (
        this.exec_cust_gateway_000 != null &&
        this.exec_cust_gateway_000.length > 0
      ) {
        this.filterDevice = this.exec_cust_gateway_000.filter(function (
          item,
          index,
          array
        ) {
          return item.gw_desc == val;
        });

        if (this.filterDevice != null && this.filterDevice.length > 0) {
          this.didChange("01");
          let nform = {
            cond: this.filterDevice[0].ip_adrs,
          };

          this.$store
            .dispatch("exec_equip_valname_000", nform)
            .then((res) => {
              if (res != null && res.length > 0) {
                this.didList = res.map(function (item) {
                  return item.did;
                });

                this.didList = this.didList.filter(this.onlyUnique);
                //this.didList.unshift("ALL");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    didChange(val) {
      let vall = val + " ";

      let nform = {
        cond: this.filterDevice[0].ip_adrs,
        did: vall,
      };
      this.fieldSensorList = [];
      this.$store
        .dispatch("exec_device_now_v2_000", nform)
        .then((res) => {
          if (res != null && res.length > 0) {
            this.fieldSensorList = res.map(function (item) {
              let obj = {
                val_name: item.c_val_name + "(" + item.val_name + ")",
                key: item.ip_adrs + " " + item.dat,
                value: "",
                val: item.c_val_name,
              };
              return obj;
            });

            this.removeDuplicates(this.fieldSensorList, "key");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fieldChangeAna2(val) {
      if (
        this.exec_cust_gateway_000 != null &&
        this.exec_cust_gateway_000.length > 0
      ) {
        this.filterDevice2 = this.exec_cust_gateway_000.filter(function (
          item,
          index,
          array
        ) {
          return item.gw_desc == val;
        });

        if (this.filterDevice2 != null && this.filterDevice2.length > 0) {
          this.didChange2("01");
          let nform = {
            cond: this.filterDevice2[0].ip_adrs,
          };

          this.$store
            .dispatch("exec_equip_valname_000", nform)
            .then((res) => {
              if (res != null && res.length > 0) {
                this.didList2 = res.map(function (item) {
                  return item.did;
                });

                this.didList2 = this.didList2.filter(this.onlyUnique);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    didChange2(val) {
      let vall = val + " ";
      let nform = {
        cond: this.filterDevice2[0].ip_adrs,
        did: vall,
      };
      this.fieldSensorList2 = [];
      this.$store
        .dispatch("exec_device_now_v2_000", nform)
        .then((res) => {
          if (res != null && res.length > 0) {
            this.fieldSensorList2 = res.map(function (item) {
              let obj = {
                val_name: item.c_val_name + "(" + item.val_name + ")",
                key: item.ip_adrs + " " + item.dat,
                value: "",
                val: item.c_val_name,
              };
              return obj;
            });

            this.removeDuplicates(this.fieldSensorList2, "key");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    
 
    serachBtn() {
      let that = this;
      // console.log("that.twice", that.twice);
      // console.log("that.searchagain", that.searchagain);

      if (that.twice) {
        if (that.searchagain >= 2) {
          that.searchagain = 0;
          that.twice = false;
          return;
        }
      }
      this.fieldSensorValue = this.fieldSensorList.filter(function (
        item,
        index,
        array
      ) {
        if (item.value == true) {
          return item.val;
        }
      });

      this.fieldSensorValue2 = this.fieldSensorList2.filter(function (
        item,
        index,
        array
      ) {
        if (item.value == true) {
          return item.val;
        }
      });

      let loader = Vue.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });

      const start = moment(this.fromdatetime);
      const end = moment(this.todatetime);

      console.log(this.todatetime, end);
      const range = moment.range(start, end);

      let acc = Array.from(range.by("day", { step: 1 }));
      for (let month of range.by("days")) {
        let mon = month.format("YYYY-MM-DD");
      }

      let promiseall = [];
      if (this.fieldSensorValue != null && this.fieldSensorValue.length > 0) {
        for (var i = 0; i < this.fieldSensorValue.length; i++) {
          let item = this.fieldSensorValue[i];
          if (item.value) {
          } else {
            continue;
          }
          let sensorvalu = item.val;
          promiseall.push(this.chartajax(sensorvalu));
        }
      }

      if (this.fieldSensorValue2 != null && this.fieldSensorValue2.length > 0) {
        for (var i = 0; i < this.fieldSensorValue2.length; i++) {
          let item = this.fieldSensorValue2[i];
          if (item.value) {
          } else {
            continue;
          }
          let sensorvalu = item.val;

          //  console.log("chartajax2", sensorvalu);
          promiseall.push(this.chartajax2(sensorvalu));
        }
      }

      this.exportBtnShow = false;
      this.showloading = true;

      Promise.all(promiseall)
        .then((values) => {
          loader.hide();

          if (values != null && values.length == 0) {
            this.snackbar = true;
            this.text = "沒有資料";
            this.showloading = false;
            return;
          }
          if (values != null && values.length > 0) {
            if (values[0] != null && values[0].length > 0) {
              if (values[0][0].hasOwnProperty("gw_desc")) {
              } else {
                this.snackbar = true;
                this.text = "沒有資料";
                this.showloading = false;
                return;
              }
            } else {
              this.snackbar = true;
              this.text = "沒有資料";
              this.showloading = false;
              return;
            }
          }

          that.searchagain = that.searchagain + 1;

          let labels = [];
          let datasets = [];
          this.json_data = [];
          if (values != null && values.length > 0) {
            for (var i = 0; i < values.length; i++) {
              let valueitem = values[i];
              labels = [];
              let dataarr = [];
              for (var j = 0; j < valueitem.length; j++) {
                let datearr = valueitem[j].mdat.split(" ");
                // labels.push(datearr[1]);

                labels.push(valueitem[j].mdat);
                dataarr.push(valueitem[j].value);

                let json = {
                  val_name:
                    valueitem[j].c_val_name + "(" + valueitem[j].val_name + ")",
                  did: valueitem[j].did,
                  value: valueitem[j].value,
                  val_unit: valueitem[j].val_unit,
                  dat: valueitem[j].mdat,
                };

                this.json_data.push(json);
              }

              let backgroundidx = i;
              if (i > 7) {
                backgroundidx = backgroundidx - 8;
              }
              // line chart attr.
              let obj = {
                label: valueitem[0].c_val_name,
                borderWidth: 1,
                backgroundColor: [this.backgroundColor[backgroundidx]],
                borderColor: [this.backgroundColor[backgroundidx]],
                pointBorderColor: [this.backgroundColor[backgroundidx]],
                data: dataarr,
                pointBorderColor: "transparent",
                backgroundColor: "transparent",
                plugins: { zoom: { zoom: { wheel: { enabled: true, }, pinch: { enabled: true }, mode: 'x', } }, },


              };
              datasets.push(obj);
            }
            that.chartAna = {
              labels: labels,
              datasets: datasets,
            };
            that.$forceUpdate();
            this.showloading = false;
            that.chartshow = true;
            this.exportBtnShow = true;
            
            if (that.twice) {
              this.serachBtn();
            }
          }
        })
        .catch((error) => {
          loader.hide();
          console.log(error);
        });
    },
    chartajax(sensorvalu) {
      return new Promise((resolve, reject) => {
        let s_dat = this.fromdatetime;
        s_dat = moment(s_dat).format("YYYY-MM-DD HH:mm:ss");

        let e_dat = this.todatetime; //+ " 23:59:59";
        e_dat = moment(e_dat).format("YYYY-MM-DD HH:mm:ss");

        //console.log(s_dat, e_dat);

        let nform = {
          ip_adrs: this.filterDevice[0].ip_adrs,
          did: this.didListValue,
          e_dat: e_dat,
          s_dat: s_dat,
          c_val_name: encodeURI(sensorvalu),
        };
        this.$store
          .dispatch("exec_history_000", nform)
          .then((res1) => {
            // console.log(res1);
            let filterdata = [];
            if (res1 != null && res1.length > 0) {
              for (var j = 0; j < res1.length; j++) {
                let sensordata = res1[j];
                if (
                  sensordata.c_val_name == sensorvalu &&
                  this.didListValue == sensordata.did
                ) {
                  filterdata.push(sensordata);
                }
              }
            }
            resolve(filterdata);
          })
          .catch((err) => {
            reject(err);
            console.log(err);
          });
      });
    },
    chartajax2(sensorvalu) {
      return new Promise((resolve, reject) => {
        let s_dat = this.fromdatetime;
        s_dat = moment(s_dat).format("YYYY-MM-DD HH:mm:ss");

        let e_dat = this.todatetime; //+ " 23:59:59";
        e_dat = moment(e_dat).format("YYYY-MM-DD HH:mm:ss");

        //console.log(s_dat, e_dat);

        let nform = {
          ip_adrs: this.filterDevice2[0].ip_adrs,
          did: this.didListValue2,
          e_dat: e_dat,
          s_dat: s_dat,
          c_val_name: encodeURI(sensorvalu),
        };
        this.$store
          .dispatch("exec_history_000", nform)
          .then((res1) => {
            // console.log(res1);
            let filterdata = [];
            if (res1 != null && res1.length > 0) {
              for (var j = 0; j < res1.length; j++) {
                let sensordata = res1[j];
                if (
                  sensordata.c_val_name == sensorvalu &&
                  this.didListValue2 == sensordata.did
                ) {
                  filterdata.push(sensordata);
                }
              }
            }
            resolve(filterdata);
          })
          .catch((err) => {
            reject(err);
            console.log(err);
          });
      });
    },
    exportBtn() {},
  },
};
</script>

<style>
.checkbox {
  float: left;
  margin-top: 0px;
 
  margin-bottom: 20px;
}
</style>
 

<style>
.chartAna {
  /* width: 100% !important; */
  margin-right: 10px;
  float: left;
  
  /* height: 400px !important; */
}
</style>

<style lang="scss">
.chartDiv {
  flex-grow: 1;
  min-height: 0;
  background-color: rgb(36, 37, 37);
  
  > div {
    position: relative;
    height: 600px;
    width: 100%;
    
    > div {
      height: 600px;
      width: 100%;

      > canvas {
        height: 600px;
        width: 100% !important;
      }
    }
  }
}

.searchbg1 {
  
  background: #cc3333;
  border-radius: 10px;
  padding: 10px;
}
.date.v-input input,
.theme--light.v-input textarea {
  color: white !important;
}

.date .theme--light.v-icon {
  color: white !important;
}

.dateselect {
  color: white;
}

</style>

<style scoped>
#ana{
height: 100%;
background-color: #636668;
}
</style>

